import { useState } from 'react';

import { useTranslation } from '@cms/i18n/client';
import { logger } from '@common/logger';

export interface Props {
    value: string | null;
    inputProps: any;
}
interface dateRangeType {
    from: string;
    to: string;
}

const dateRangeRegex: RegExp = /^\[(.+?)TO(.+?)\]$/i;
const dateRegex: RegExp = /(\*|\d{4}(\-)(((0)[0-9])|((1)[0-2]))(\-)([0-2][0-9]|(3)[0-1]))/gi;

const parseObjectToString = (val: dateRangeType): string => {
    let from: string = val.from;
    let to: string = val.to;

    if (from === '' && to === '') {
        return '';
    }

    if (to === '') to = '*';
    if (from === '') from = '*';
    return '[' + from + 'TO' + to + ']';
};

const parseValueToObject = (val: string | null): dateRangeType => {
    let from: string = '';
    let to: string = '';
    if (val) {
        if (!dateRangeRegex.test(String(val))) {
            logger.debug('unexpected dateRange format');
        } else {
            const parts = val.match(dateRegex);
            if (parts?.length === 2) {
                from = parts[0];
                if (from === '*') from = '';

                to = parts[1];
                if (to === '*') to = '';
            }
        }
    }

    return { from, to };
};

export const DateRange = ({ inputProps, value }: Props) => {
    const __components = useTranslation('components').t;

    const [dateRangeValue, setDateRangeValue] = useState<dateRangeType>(parseValueToObject(value));

    const innerProps = {
        id: inputProps?.id,
        name: inputProps?.name,
        type: 'date',
        min: '1900-01-01',
        max: '2100-01-01',
    };

    const handleInputChange = (rangeObject: dateRangeType) => {
        const dateAsString: string = parseObjectToString(rangeObject);
        const newDateRange: dateRangeType = parseValueToObject(dateAsString);
        setDateRangeValue(newDateRange);
    };

    return (
        <label>
            {__components`InputElement.title.from`}
            <input
                {...innerProps}
                id={innerProps.id + 'from'}
                key={innerProps.id + 'from'}
                value={dateRangeValue.from}
                onChange={(event) => {
                    handleInputChange({ from: event.target.value, to: dateRangeValue.to });
                }}
            />
            {__components`InputElement.title.to`}
            <input
                {...innerProps}
                id={innerProps.id + 'to'}
                key={innerProps.id + 'to'}
                value={dateRangeValue.to}
                onChange={(event) => {
                    handleInputChange({ from: dateRangeValue.from, to: event.target.value });
                }}
            />
            <input {...inputProps} type="hidden" value={parseObjectToString(dateRangeValue)} />
        </label>
    );
};
